(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    /* Enforce the chosen mute state on every <video> in this block,
     even if the parent snippet doesn't honor the muted parameter. */
  (function () {
    function applyMuteState() {
      document.querySelectorAll('.video-block-wrapper').forEach(function (wrapper) {
        var shouldMute = wrapper.dataset.videoMuted === 'true';
        wrapper.querySelectorAll('video').forEach(function (v) {
          v.muted = shouldMute;
          if (shouldMute) {
            v.setAttribute('muted', '');
          } else {
            v.removeAttribute('muted');
          }
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyMuteState);
    } else {
      applyMuteState();
    }
    document.addEventListener('shopify:section:load', applyMuteState);
  })();
  } catch(e) { console.error(e); }
})();

})();
